// Лимит тарифа 9999 показываем как «Unlimited». Сервер считает по числу как обычно:
// это просто большой лимит, а не отсутствие ограничения. disk_space сюда не относится —
// он в MB и выводится размером.
export const UNLIMITED_LIMIT = 9999;

// сервер отдаёт лимиты строками ("9999"), поэтому сравниваем как число
export function isUnlimitedLimit(value) {
  return (
    value !== null &&
    value !== undefined &&
    value !== "" &&
    Number(value) === UNLIMITED_LIMIT
  );
}

// значение лимита для показа: 9999 → подпись unlimitedLabel, остальное как есть
export function formatPlanLimit(value, unlimitedLabel) {
  return isUnlimitedLimit(value) ? unlimitedLabel : value;
}
